import React, { useEffect, useState } from "react";

import "./membership_selection.css";
import Grid from "@mui/material/Grid2";
import {
  Box,
  Button,
  Chip,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import logo from "../../images/PPKM_Head.png";
import getEventController from "../Member/Controller/getEvent_controller";

const MembershipSelection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state; // Access passed data
  console.log(email);
  const [selectedMembership, setSelectedMembership] = useState("");
  const [activeMembers, setActiveMembers] = useState([]);

  const handleSelectionChange = (id) => {
    setSelectedMembership(id);
  };

  //get Membership Info by MemberId
  useEffect(() => {
    getEventController
      .FetchActiveMembershipsByEmail(email)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          const activeMemberList = response.map((item) => ({
            membershipNo: item.memberID,
            company_name: item.company_name,
            account_type: item.type,
            user_id: item.userID,
            email: email,
          }));
          setActiveMembers(activeMemberList);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [email]);

  const getMembershipType = (membershipType) => {
    if (membershipType === 0) return "Appointed";
    if (membershipType === 1) return "Alternate";
    if (membershipType === 2) return "Others";
  };

  const handleCheckPassword = async (e) => {
    e.preventDefault();
    console.log(selectedMembership);

    // Call the authentication function
    const data = await getEventController.CheckMemberPasswordByUserID(
      selectedMembership,
      email
    );

    console.log(data);

    if (data.success == "true") {
      navigate("/password_authentication", {
        state: {
          email,
          userID: selectedMembership,
          companyName: data.companyName,
          memberId: data.memberId,
        },
      });
    } else if (data.success !== "true") {
      navigate("/first_time_otp", {
        state: {
          email,
          userID: selectedMembership,
          companyName: data.companyName,
          memberId: data.memberId,
          sent_otp: data.otp,
        },
      });
    }
    //   // If successful, navigate to the next page, e.g., OTP page or dashboard
    //   navigate("/otp", { state: { email, sent_otp: data } });
    //   // console.log(data);
    // } else {
    //   setError("Invalid email. Please try again.");
    // }
  };

  return (
    <div className="retrieve-email-page">
      <div className="d-flex retrieve-email-container">
        <div className="retrieve-email-wrapper">
          <div className="login-title">
            <img className="web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="title_para">MEMBERSHIP SELECTION</p>
          <p className="re-span">Select an account below you wish to proceed</p>
          <form className="retrieve-email-form" onSubmit={handleCheckPassword}>
            <div className="fpf-row">
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    backgroundColor: "#b24743",
                    color: "white",
                    padding: "8px 8px 8px 50px",
                    fontWeight: "bold",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  {/* <Grid container>
                    <Grid item xs={4}>
                      {" "}
                    </Grid>
                  </Grid> */}
                  <Grid container>
                    <Grid item xs={6}>
                      Membership No.
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={3}>
                      Company Name
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={3}>
                      Account Type
                    </Grid>
                  </Grid>
                </Box>

                {/* Membership List */}
                <RadioGroup
                  value={selectedMembership}
                  //   onChange={handleSelectionChange}
                  sx={{
                    "& .MuiFormControlLabel-root": {
                      margin: 0,
                    },
                    padding: "5px",
                  }}
                >
                  {activeMembers.map((member, index) => (
                    <Box
                      key={index}
                      onClick={() => handleSelectionChange(member.user_id)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor:
                          selectedMembership === member.user_id
                            ? "#c33d3d"
                            : "white",
                        color:
                          selectedMembership === member.user_id
                            ? "white"
                            : "black",
                        cursor: "pointer",
                        borderBottom: "1px solid #ccc",
                        "&:last-child": {
                          borderBottom: "none",
                        },
                        justifyContent: "space-between",
                        borderRadius: "25px",
                        paddingRight: "10px",
                      }}
                    >
                      {/* <Grid container> */}
                      <FormControlLabel
                        value={member.user_id}
                        control={
                          <Radio
                            sx={{
                              color: "black",
                              "& .MuiSvgIcon-root": {
                                fontSize: 18,
                              },
                              "&.Mui-checked": {
                                color: "white",
                              },
                            }}
                          />
                        }
                        label=""
                        sx={{
                          marginRight: "8px",
                          color:
                            selectedMembership === member.user_id
                              ? "white"
                              : "black",
                        }}
                      />
                      {/* </Grid> */}
                      <Grid container>
                        <Grid item xs={4}>
                          <Typography className="m-label">
                            {member.membershipNo}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={4}>
                          <Typography className="m-label">
                            {member.company_name}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={4}>
                          <Chip
                            className="m-label"
                            label={getMembershipType(member.account_type)}
                            size="small"
                            sx={{
                              backgroundColor: "#aaa",
                              color: "black",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </RadioGroup>
              </Box>
            </div>
            <div>
              <Button
                className="reset-button"
                type="submit"
                // onClick={() => navigate("/password_authentication")}
              >
                Next
              </Button>
            </div>
            <div>
              <Button
                className="reset-button"
                onClick={() => navigate("/login")}
              >
                Return to Login Page
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MembershipSelection;
